import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/custom-validators';
import { AccountService } from 'src/app/services/account.service';
import { Account } from 'src/app/models/account';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
  public accountForm: FormGroup;
  public passwordForm: FormGroup;
  private account: Account;
  public errors:string;
  public passwordErrors =[];
  public accountUpdated = false;
  public passwordUpdated = false;
  public savingAccount = false;
  public savingPassword = false;
  public loading: boolean = true;

  constructor(
    private accountService: AccountService
  ) {
    this.account = this.accountService.getLocalAccount();
    this.accountForm = new FormGroup({
      'email': new FormControl(this.account.email, [
        Validators.email,
        Validators.required
      ]),
      'first_name': new FormControl(this.account.first_name, Validators.required),
      'last_name': new FormControl(this.account.last_name, Validators.required),
    });
    this.passwordForm = new FormGroup({
      'current_password': new FormControl(null, [Validators.required]),
      'password': new FormControl(null, [Validators.required,Validators.minLength(8)]),
      'password_confirmation': new FormControl(null, Validators.required),
    },{
      validators: CustomValidators.MatchPassword
    });
  }

  ngOnInit() {
  }

  save(){
    this.errors='';
    this.accountUpdated = false;
    this.savingAccount = true;
    this.account.first_name = this.accountForm.get('first_name').value;
    this.account.last_name = this.accountForm.get('last_name').value;
    this.account.email = this.accountForm.get('email').value;

    this.accountService.saveAccount(this.account).subscribe(res=>{
      this.accountUpdated = true;
      this.savingAccount = false;
    },err=>{
      let errorObject = JSON.parse(err.error);
      this.savingAccount = false;
    })
  }

  savePassword(){
    this.passwordErrors =[];
    this.passwordUpdated = false;
    this.savingPassword = true;
    this.accountService.savePassword(this.passwordForm.get('password').value,this.passwordForm.get('password_confirmation').value, this.passwordForm.get('current_password').value).subscribe(res=>{
      if (res.error) {
        this.errors=res.error;
        this.savingPassword = false;
      } else {
        this.passwordUpdated = true;
        this.passwordForm.reset();
        this.savingPassword = false;
      }
    },err=>{
      this.savingPassword = false;
    })
  }
}
